module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/12-a70ebc3d3281c1a257ca549b395796cb.png";